import Callout from 'components/tools/Callout';
import moment from 'moment';
import nextTick from 'helpers/nextTick';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {BranchSelect} from 'components/forms';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {getConjoinedContacts} from 'api/dataCleanup';
import {Loader, Card, Row, Col, SearchField} from 'components';
import {Table, Button, PageFooter, Pagination, Icon} from 'components/layout';

const pagePropTypes = {
  setResults: PropTypes.func.isRequired,
  results: PropTypes.array.isRequired,
  selectContact: PropTypes.func.isRequired,
  blacklist: PropTypes.object.isRequired,
};

class Page extends Component {
  displayName = 'Page';

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      page: 1,
      sortKey: 'name',
      sortDirection: 'asc',
    };
  }

  componentWillMount() {
    this._fetch();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.page !== this.state.page || prevState.sortKey !== this.state.sortKey || prevState.sortDirection !== this.state.sortDirection) {
      this._fetch(prevState.page === this.state.page);
    }
  }

  componentWillUnmount() {
    this.props.setSearch(this.search.value);
  }

  onPageChange = page => {
    this.setState({page});
  };

  _fetch = (updatePage = false) => {
    getConjoinedContacts({
      branches: this.branches ? this.branches.getWrappedInstance().getValue() : null,
      page: this.state.page,
      size: 25,
      search: this.search ? this.search.value : this.props.search,
      sort: this.state.sortKey,
      sortDirection: this.state.sortDirection,
    })
      .then(res => {
        this.setState({
          total: res.total,
          page: updatePage ? 1 : res.page,
          size: res.size,
          loaded: true,
        });
        this.props.setResults(res.documents);
      });
  };

  sort = key => {
    if (this.state.sortKey === key) {
      this.setState({
        sortDirection: this.state.sortDirection === 'asc' ? 'desc' : 'asc',
      });
    } else {
      this.setState({
        sortDirection: 'asc',
        sortKey: key,
      });
    }
  };

  render() {
    let {formatMessage} = this.props.intl;
    let headings = [
      undefined,
      {label: formatMessage({id: 'general.account'}), sortKey: 'accountNo'},
      {label: formatMessage({id: 'general.customer'}), sortKey: 'name'},
      formatMessage({id: 'general.address'}),
      undefined,
    ];

    let rows = this.props.results
      .filter(x => !this.props.blacklist.has(x.Id))
      .map(x => <Record accountNumber={x.accountNo} name={x.name} address={x.address1} id={x.id}
        favourite={x.fav} flag={x.flag} truBlue={x.truBlue ? moment(x.truBlue) : null} truBlueExpiry={x.truBlueExpiry ? moment(x.truBlueExpiry) : null}
        select={() => this.props.selectContact(x)} formatMessage={formatMessage} />);

    return <div>
      <Loader loaded={this.state.loaded}>
        <Card fullWidth>
          <Row>
            <Col md={4}>
              <BranchSelect ref={b => this.branches = b} onChange={() => this._fetch()} />
            </Col>
            <Col md={5}>
              <SearchField onSearch={() => this._fetch(true)} ref={s => this.search = s} initialValue={this.props.search}
                placeholder={formatMessage({id: 'general.search.special.character'})} autoFocus={false} />
            </Col>
          </Row>
          <Row>
            <Col md={12} className='semi-bold'>
              <i className='bl bl-help-circle blue fa-lg' />
              <FormattedMessage id="tools.split.two.names" values={{count: <Callout>{this.state.total || 0}</Callout>}} />
            </Col>
          </Row>
        </Card>
        <Table headings={headings} rows={rows} currentSort={this.state.sortKey} sortDirection={this.state.sortDirection} sort={this.sort} />
        <PageFooter className='tc'>
          <Pagination onPageChange={this.onPageChange} page={this.state.page} count={25} total={this.state.total} />
        </PageFooter>
      </Loader>
    </div>;
  }
}
Page.propTypes = pagePropTypes;

const Record = ({name, accountNumber, address, id, select, flag, favourite, truBlueActive, truBlueInactive, formatMessage}) => {
  let star;

  if (truBlueActive) {
    star = <i className='bl bl-tru-blue-filled fa-lg blue' title={formatMessage({id: 'general.trublue.active'})} />;
  } else if (truBlueInactive) {
    star = <i className='bl bl-tru-blue-filled fa-lg grey' title={formatMessage({id: 'general.trublue.inactive'})} />;
  } else if (favourite) {
    star = <i className='bl bl-star-filled fa-lg star' title={formatMessage({id: 'general.preferred.customer'})} />;
  }

  return <tr>
    <td>
      {flag ? <Icon lg name='flag-filled' /> : null}
      {star}
    </td>
    <td>{accountNumber}</td>
    <td>{name}</td>
    <td>{address}</td>
    <td><Button link underline onClick={select}><FormattedMessage id="tools.split.view.contacts" /></Button></td>
  </tr>;
};

export default injectIntl(Page);
